// extracted by mini-css-extract-plugin
export default {"date":"FileEntry_date__8SDc8"};